function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-158 -679.5)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 30,
  r: 30,
  transform: "translate(158.5 680)",
  fill: "none",
  stroke: "#25a4b4",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(159 644.664)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(21.583 54.336)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 5.286,
  cy: 5.286,
  r: 5.286,
  transform: "translate(0.552 0.562)",
  fill: "#25a4b4"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M92.07,60.184a4.721,4.721,0,1,1-3.786-4.632,4.77,4.77,0,0,1,3.786,4.632.564.564,0,0,0,1.128,0A5.853,5.853,0,1,0,88.5,65.916,5.924,5.924,0,0,0,93.2,60.184.564.564,0,0,0,92.07,60.184Z",
  transform: "translate(-81.51 -54.336)",
  fill: "#25a4b4"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(18 67.27)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M45.732,300.392a32.714,32.714,0,0,1-17.732,0v-.073a6.718,6.718,0,0,1,6.719-6.719h4.3a6.718,6.718,0,0,1,6.719,6.719v.073Z",
  transform: "translate(-27.436 -293.036)",
  fill: "#25a4b4"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M36.149,290.415a32.168,32.168,0,0,1-14.115.75,33.193,33.193,0,0,1-3.317-.75c.135.181.276.361.412.542a6.233,6.233,0,0,1,2.183-4.773,6.311,6.311,0,0,1,4.175-1.45H29.08a8.847,8.847,0,0,1,1.444.068,6.3,6.3,0,0,1,2.561,1.021,6.221,6.221,0,0,1,2.652,5.134.564.564,0,0,0,1.128,0,7.366,7.366,0,0,0-2.426-5.5,7.455,7.455,0,0,0-4.993-1.856H25.7a7.72,7.72,0,0,0-4.666,1.371A7.4,7.4,0,0,0,18,290.957a.569.569,0,0,0,.412.542,33.556,33.556,0,0,0,14.668.762,33,33,0,0,0,3.368-.762A.562.562,0,0,0,36.149,290.415Z",
  transform: "translate(-18 -283.6)",
  fill: "#25a4b4"
})))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(166 619.604)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 1,
  height: 7,
  rx: 0.5,
  transform: "translate(30 86.396)",
  fill: "#25a4b4"
}), /*#__PURE__*/React.createElement("rect", {
  width: 1,
  height: 7,
  rx: 0.5,
  transform: "translate(34 89.396) rotate(90)",
  fill: "#25a4b4"
})));

var SvgAddPerson = function SvgAddPerson(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAddPerson, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/add-person.49dd2d57.svg";
export { ForwardRef as ReactComponent };